module.exports = __webpack_public_path__ + "img/logo_utrust.2c25f460.jpg";